import {connectWithCore} from 'framework/hocs';
import {Link} from 'app-ui-componentlibrary/dist/componentLibrary/layout/Link';

export default connectWithCore(Link);
